import { returnToVendor as returnToVendorEn } from '../en/returnToVendor';

export const returnToVendor = {
  ...returnToVendorEn,
  returnToVendors: 'சப்ளையருக்கு திரும்பப் பொருட்கள்',
  allReturnToVendors: 'அனைத்து சப்ளையர் திரும்பல்கள்',
  createReturnToVendor: 'சப்ளையர் திரும்பலை உருவாக்கவும்',
  returnToVendorDetails: 'சப்ளையர் திரும்பல் விவரங்கள்',
  status_completed: 'முடிந்தது',
  status_voided: 'ரத்து செய்யப்பட்டது',
  viewAndManageAllReturnToVendors: "அனைத்து சப்ளையர் திரும்பல்களையும் பார்த்து நிர்வகிக்கவும்",
  createReturnToVendorDescription: "பெறப்பட்ட பொருட்கள் குறிப்புக்கு எதிராக பொருட்களை சப்ளையருக்குத் திருப்பி அனுப்பவும்",
  rtvNumber: "RTV எண்",
  purchaseOrderNumber: "கொள்முதல் ஆர்டர்",
  grnNumber: "GRN எண்",
  supplier: "சப்ளையர்",
  totalDebitAmount: "மொத்த டெபிட் தொகை",
  createdAt: "உருவாக்கப்பட்ட தேதி",
  createdBy: "உருவாக்கியவர்",
  status: "நிலை",
  actions: "செயல்கள்",
  item: "பொருள்",
  warehouse: "கிடங்கு",
  details: "திரும்பல் விவரங்கள்",
  itemsToReturn: "திருப்பி அனுப்ப வேண்டிய பொருட்கள்",
  itemsReturned: "திருப்பி அனுப்பிய பொருட்கள்",
  returnableQuantity: "திருப்பக்கூடிய அளவு",
  quantityReturned: "திருப்பிய அளவு",
  unitPriceLabel: "அலகு விலை",
  lineAmount: "வரித் தொகை",
  unitsSelected: "அலகுகள் தேர்ந்தெடுக்கப்பட்டன",
  linkedDebitNotes: "இணைக்கப்பட்ட டெபிட் குறிப்புகள்",
  lookupGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பைத் தேடவும்",
  goodsReceivedNoteIdPlaceholder: "பெறப்பட்ட பொருட்கள் குறிப்பைத் தேர்ந்தெடுக்கவும்",
  purchaseOrderIdPlaceholder: "கொள்முதல் ஆர்டர் ID அல்லது எண்ணை உள்ளிடவும்",
  grnIdPlaceholder: "GRN ID அல்லது எண்ணை உள்ளிடவும்",
  lookupButton: "தேடு",
  selectGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பைத் தேர்ந்தெடுக்கவும்",
  multipleGoodsReceivedNotesFound: "இந்த ஆர்டருக்கு பல GRN கள் உள்ளன — ஒன்றைத் தேர்ந்தெடுக்கவும்",
  goodsReceivedNoteNotFound: "பெறப்பட்ட பொருட்கள் குறிப்பு கிடைக்கவில்லை",
  purchaseOrderNotFound: "கொள்முதல் ஆர்டர் கிடைக்கவில்லை",
  reason: "காரணம்",
  reasonPlaceholder: "திருப்பி அனுப்புவதற்கான காரணம் (விருப்பத்தேர்வு)",
  returnFromWarehouse: "திருப்பி அனுப்பும் கிடங்கு",
  selectWarehouse: "கிடங்கைத் தேர்ந்தெடுக்கவும்",
  create: "சப்ளையர் திரும்பலை உருவாக்கவும்",
  save: "சேமி",
  voidReturnToVendor: "சப்ளையர் திரும்பலை ரத்து செய்யவும்",
  void: "ரத்து செய்",
  print: "அச்சிடு",
  printReturnToVendor: "சப்ளையர் திரும்பலை அச்சிடவும்",
  backToReturnToVendors: "சப்ளையர் திரும்பல்களுக்குத் திரும்பு",
  confirmVoid: "இந்தத் திரும்பலை ரத்து செய்ய விரும்புகிறீர்களா? கையிருப்பு மீட்டமைக்கப்படும், இணைக்கப்பட்ட டெபிட் குறிப்பும் ரத்து செய்யப்படும்.",
  voidReason: "ரத்து செய்வதற்கான காரணம்",
  voidReasonPlaceholder: "ரத்து செய்வதற்கான காரணத்தை உள்ளிடவும் (விருப்பத்தேர்வு)...",
  filterByPurchaseOrder: "கொள்முதல் ஆர்டர் மூலம் வடிகட்டு",
  filterByGoodsReceivedNote: "பெறப்பட்ட பொருட்கள் குறிப்பு மூலம் வடிகட்டு",
  rtvCreatedSuccessWithDebitNote: "சப்ளையர் திரும்பல் {rtvNumber} உருவாக்கப்பட்டது — டெபிட் குறிப்பு {debitNoteNumber} தானாக வழங்கப்பட்டது",
  rtvVoidedSuccessfully: "சப்ளையர் திரும்பல் வெற்றிகரமாக ரத்து செய்யப்பட்டது",
  failedToCreateReturnToVendor: "சப்ளையர் திரும்பலை உருவாக்க முடியவில்லை",
  failedToLoadReturnToVendors: "சப்ளையர் திரும்பல்களை ஏற்ற முடியவில்லை",
  failedToLoadReturnToVendor: "சப்ளையர் திரும்பலை ஏற்ற முடியவில்லை",
  failedToVoidReturnToVendor: "சப்ளையர் திரும்பலை ரத்து செய்ய முடியவில்லை",
  someFieldsRequired: "சமர்ப்பிக்கும் முன் முன்னிலைப்படுத்தப்பட்ட புலங்களைச் சரிசெய்யவும்",
  goodsReceivedNoteRequired: "பெறப்பட்ட பொருட்கள் குறிப்பைத் தேர்ந்தெடுக்கவும்",
  atLeastOneItemRequired: "திருப்பி அனுப்ப குறைந்தது ஒரு பொருளைத் தேர்ந்தெடுக்கவும்",
  unitPriceRequired: "அலகு விலையை உள்ளிடவும்",
  warehouseRequired: "கிடங்கைத் தேர்ந்தெடுக்கவும்",
  noReturnToVendorsFound: "சப்ளையர் திரும்பல்கள் எதுவும் இல்லை",
  noReturnToVendorsYet: "இன்னும் சப்ளையர் திரும்பல்கள் இல்லை.",
  noReturnToVendorsFoundDescription: "உங்கள் தற்போதைய வடிப்பான்களுடன் பொருந்தும் திரும்பல்கள் இல்லை",
  noReturnToVendorsYetDescription: "சப்ளையருக்கு பொருட்களைத் திருப்பி அனுப்ப உங்கள் முதல் திரும்பலை உருவாக்கவும்.",
  createFirstReturnToVendor: "முதல் சப்ளையர் திரும்பலை உருவாக்கவும்",
  searchGoodsReceivedNote: "GRN அல்லது கொள்முதல் ஆர்டர் எண் மூலம் தேடவும்...",
  noGoodsReceivedNotesFound: "பெறப்பட்ட பொருட்கள் குறிப்புகள் எதுவும் இல்லை",
  goodsReceivedNoteCancelled: "ரத்து செய்யப்பட்ட பெறப்பட்ட பொருட்கள் குறிப்புக்கு எதிராக திருப்பி அனுப்ப முடியாது",
  allStatuses: "அனைத்து நிலைகளும்",
  searchPlaceholder: "RTV, PO அல்லது GRN எண்ணால் தேடுக",
};
